import { render } from "./Patent.vue?vue&type=template&id=398b4b32&scoped=true"
import script from "./Patent.vue?vue&type=script&lang=js"
export * from "./Patent.vue?vue&type=script&lang=js"

import "./Patent.vue?vue&type=style&index=0&id=398b4b32&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398b4b32"]])

export default __exports__